let currentApplication;

const getTizenLibrary = () => {
  return window.tizen;
};

const getTizenTvInputDevice = () => {
  return getTizenLibrary().tvinputdevice;
};

const getSupportedKeys = () => {
  return getTizenTvInputDevice().getSupportedKeys();
};

const getTizenCurrentApp = () => {
  const tizenLibrary = getTizenLibrary();
  if (!currentApplication) {
    currentApplication = tizenLibrary.application.getCurrentApplication();
  }
  return currentApplication;
};

const getTizenRequestedAppControl = () => {
  const tizenCurrentApp = getTizenCurrentApp();
  if (tizenCurrentApp) {
    return tizenCurrentApp.getRequestedAppControl();
  }
  return null;
};

const getTizenAppControl = () => {
  const requestedAppControl = getTizenRequestedAppControl();
  if (requestedAppControl) {
    return requestedAppControl.appControl;
  }
  return null;
};

const getTizenAppControlData = () => {
  const appControl = getTizenAppControl();
  if (appControl) {
    return appControl.data;
  }
  return null;
};

const getTizenControlOperation = () => {
  const requestedAppControl = getTizenAppControl();
  if (requestedAppControl) {
    return requestedAppControl.operation;
  }
  return null;
};

export default {
  getTizenAppControl,
  getTizenAppControlData,
  getTizenControlOperation,
  getTizenCurrentApp,
  getTizenLibrary,
  getTizenRequestedAppControl,
  getSupportedKeys,
  getTizenTvInputDevice
};
